import { Action } from '../../models/user/user.model';

export type UserState = Omit<Action, 'country_code' | 'country_order'>;

export const initialState: UserState = {} as UserState;
